import React from 'react'
import { Link } from 'react-router-dom'
import iconKm from '../images/icons/km.png'
import iconTransmission from '../images/icons/transmission.png'
import iconCarState from '../images/icons/carstate.png'
import iconDetalles from '../images/icons/checklist.png'
import iconColor from '../images/icons/paint.png'
import iconMotor from '../images/icons/engine.png'
import iconTanque from '../images/icons/fuel.png'
import iconCliente from '../images/icons/client-call.png'
import '../styles/Detalles.css'

class Detalles extends React.Component {
    
    state = {}

    render(){
        // Get the form from the state
        const { form } = this.props

        // Set values to show on the screen
        let tipoDeGasolina = "Tipo de gasolina: "+form.gas
        let caballosDeFuerza = form.horsepower+" Horse Power"
        
        // Format the price to show in quetzales
        let precio = parseInt(form.price, 10)
        let precioFinal =  'Q.' + precio.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        
        // Check if the car is used or not
        let estadoDeCarro = ""
        if(form.used){
            estadoDeCarro = "Carro usado"
        }
        else {
            estadoDeCarro = "Carro nuevo"
        }

        // Begins the render function
        return (
            <React.Fragment>
                <h4 className="text-center my-2">
                    <small className="text-muted">Detalles de</small> <span className="text-danger">{form.brand} - {form.model} {form.year}</span>
                </h4>
                <div className="d-flex flex-row mt-1">
                    <div className="container col-md-7 d-flex justify-content-end align-items-center">
                        <img src={form.picturePath} alt={form.descrip} className="w-75 h-auto p-4 rounded" />
                    </div>
                    <div className="container col-md-5 d-flex flex-column justify-content-center">
                    <ul className="list-unstyled">
                        <li className="media">
                            <img src={iconKm} className="mr-3" alt="..."/>
                            <div className="media-body">
                                <h5 className="mt-0 mb-1">Kilometraje</h5>
                                {form.km} km
                            </div>
                        </li>
                        <li className="media my-4">
                            <img src={iconTransmission} className="mr-3" alt="..."/>
                            <div className="media-body">
                                <h5 className="mt-0 mb-1">Transmisión</h5>
                                {form.transmission}
                            </div>
                        </li>
                        <li className="media">
                            <img src={iconCarState} className="mr-3" alt="..."/>
                            <div className="media-body">
                                <h5 className="mt-0 mb-1">Estado del carro</h5>
                                {estadoDeCarro}
                            </div>
                        </li>
                    </ul>
                        <Link to={"/detalleCarro/"+form._id} className="btn btn-success w-50 py-2">Comprar {precioFinal}</Link>
                    </div>
                </div>
                <h5 className="tituloMasDetalles">Más detalles:</h5>
                <div className="masDetallesDelCarro bg-light">
                    <div className="tarjetita">
                        <img src={iconDetalles} alt="..."/>
                        <p className="tituloTarjetita">Descripción</p>
                        <p className="cuerpoTarjetita">{form.descrip}</p>
                    </div>
                    <div className="tarjetita">
                        <img src={iconColor} alt="..."/>
                        <p className="tituloTarjetita">Color</p>
                        <p className="cuerpoTarjetita">{form.color}</p>
                    </div>
                    <div className="tarjetita">
                        <img src={iconMotor} alt="..."/>
                        <p className="tituloTarjetita">Motor</p>
                        <p className="cuerpoTarjetita">{form.engine} <br/>
                        <small className="text-muted">{caballosDeFuerza}</small></p>
                    </div>
                    <div className="tarjetita" data-toggle="tooltip" data-placement="top" title={tipoDeGasolina}>
                        <img src={iconTanque} alt="..."/>
                        <p className="tituloTarjetita">Tanque</p>
                        <p className="cuerpoTarjetita">Capacidad de {form.fuelCap} galones <br/>
                        <small className="text-muted">{tipoDeGasolina}</small></p>
                    </div>
                    <div className="tarjetita">
                        <img src={iconCliente} alt="..."/>
                        <p className="tituloTarjetita">Contacto</p>
                        <p className="cuerpoTarjetita">info@cargonz.com</p>
                    </div>
                </div>                
            </React.Fragment>
        )
    }
}

export default Detalles